import { render } from "./AddFamilyContact.vue?vue&type=template&id=3d0156c4"
import script from "./AddFamilyContact.vue?vue&type=script&lang=js"
export * from "./AddFamilyContact.vue?vue&type=script&lang=js"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__